<template>
  <div class="page">
    <accordion :multiple="true" :activeIndex="[0, 1]" >
      <accordion-tab>
        <template #header>
          <span>Stai per {{ (data_.makeClone)? 'clonare': 'modificare' }} {{ data_.contrattiIds.length }} {{ (data_.contrattiIds.length != 1)? 'contratti': 'contratto' }}</span>
        </template>

        <div class="formgrid grid">

          <div class="field col-12 md:col-4">
            <label for="data_firma">Data Firma</label>
            <calendar 
              id="data_firma" 
              class="inputfield w-full"

              v-model="dataFirma" 
              :showIcon="true" 
              dateFormat="dd/mm/yy" 
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_contratto">Tipo contratto</label>
            <dropdown 
              id="cod_type_contratto" 
              v-model="data_.item.cod_type_contratto" 
              :options="data_.tipiContrattoVendita" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona tipologia..." 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_fatturazione">Tipo Fatturazione</label>
            <dropdown 
              id="cod_type_fatturazione" 
              v-model="data_.item.cod_type_fatturazione" 
              :options="data_.tipiFatturazione" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona tipologia..." 
              class="inputfield w-full"
            />
          </div>  
          
          <div class="field col-12 md:col-4">
            <label for="data_inizio">Data Inizio</label>
            <calendar 
              id="data_inizio" 
              v-model="dataInizio" 
              :showIcon="true" 
              dateFormat="dd/mm/yy"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_spedizione">Spedizione</label>
            <dropdown 
              id="cod_type_spedizione" 
              v-model="data_.item.cod_type_spedizione" 
              :options="data_.tipiSpedizione" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona tipologia..." 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_periodo">Periodo Fatturazione</label>
            <dropdown 
              id="cod_type_periodo" 
              v-model="data_.item.cod_type_periodo" 
              :options="data_.tipiPeriodoFatturazione" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona tipologia..." 
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="data_fine">Data Fine</label>
            <calendar 
              id="data_fine" 
              v-model="dataFine" 
              :showIcon="true" 
              dateFormat="dd/mm/yy"
              class="inputfield w-full" 
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_pay">Metodo Pagamento</label>
            <dropdown 
              id="cod_type_pay" 
              v-model="data_.item.cod_type_pay" 
              :options="data_.tipiMetodoPagamentoCliente" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona tipologia..." 
              :filter="true" 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_periodo">Scadenza (gg)</label>
            <dropdown 
              id="cod_type_periodo" 
              v-model="data_.item.cod_type_scadenza" 
              :options="data_.giorniScadenza" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona tipologia..." 
              :filter="true" 
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="note">Note</label>
            <prime-textarea 
              id="note" 
              v-model="data_.item.note" 
              rows="3" 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_iva">Aliquota IVA</label>
            <dropdown 
              id="cod_type_iva" 
              v-model="data_.item.cod_type_iva" 
              :options="data_.tipiAliquotaIva" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona tipologia..." 
              class="inputfield w-full" 
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_agente">Agente</label>
            <dropdown 
              id="cod_agente" 
              v-model="data_.item.cod_agente" 
              :options="data_.listaAgenti" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona agente..." 
              :filter="true" 
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="fee">Fee</label>
            <prime-input-number 
              id="fee" 
              v-model="data_.item.fee" 
              mode="decimal" 
              locale="it-IT" 
              :minFractionDigits="2" 
              :maxFractionDigits="2" 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_rid">Tipo RID</label>
            <dropdown 
              id="cod_type_rid" 
              v-model="data_.item.cod_type_rid" 
              :options="data_.tipiRid" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona tipologia..." 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_rappresentante">Rappresentante</label>
            <dropdown 
              id="cod_rappresentante" 
              v-model="data_.item.cod_rappresentante" 
              :options="data_.listaRappresentanti" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona..." 
              :filter="true" 
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="cod_type_state_ctr">Stato</label>
            <dropdown
              id="cod_type_state_ctr" 
              v-model="data_.item.stato" 
              :options="data_.tipiStatoContratto" 
              optionLabel="name" 
              optionValue="value" 
              placeholder="Seleziona..." 
              :filter="true" 
              class="inputfield w-full"
            />
            <dropdown v-if="data_.item.stato == 0" 
              v-model="data_.item.motivazione_stato" 
              :options="data_.motivazioniStatoContrattoKo" 
              optionLabel="name" 
              optionValue="id" 
              placeholder="Seleziona motivazione..." 
              :filter="true"
              class="inputfield w-full"
            />
            <input-text  v-if="data_.item.stato == 0 && data_.item.motivazione_stato == 4"
              v-model="data_.item.motivazione_stato_testo" 
              type="text"
              placeholder="Motivazione del ko..."
              class="inputfield w-full"
            />
          </div> 

        </div> 

        <div>
          <prime-checkbox id="makeClone" v-model="data_.makeClone" :binary="true" />
          <label for="makeClone" class="m-2">Crea un nuovo contratto clone</label>
        </div>

        <div class="p-d-flex p-p-3 card mt-3">
          <prime-button 
            :label="(data_.makeClone)? 'Clona contratti': 'Modifica contratti'" 
            icon="pi pi-file-o" 
            class="mb-auto"
            :disabled="( success )" 
            @click="onUpdateButton($event)" 
          />

          <div v-if="sended" class="p-d-flex">
            <span v-if="success">La {{ (data_.makeClone)? 'clonazione': 'modifica' }} dei contratti ha avuto successo</span>
            <span v-else>C&lsquo;è stato un errore</span>
          </div> 
        </div>      

      </accordion-tab>

      <accordion-tab v-if="showClonedResults">
        <template #header>
          <span>{{ (clonedContracts.length != 1)? 'Sono stati creati': "E' stato creato" }} {{clonedContracts.length }} {{ (clonedContracts.length != 1)? 'nuovi contratti': 'nuovo contratto' }}</span>
        </template>

        <div class="formgrid grid">
          <div 
            v-for="contract in clonedContracts " :key="contract.id"
            class="field col-12 md:col-2"
          >
            
            <router-link  :to="`/ask/contratti/vendita/${contract.id}/dettagli`"
              custom
              v-slot="{ href }"
            >
              <prime-button 
                icon="pi pi-file-o" 
                :label="contract.code"
                class="mb-auto" 
                @click="navigateToTab(href)" 
              />
            </router-link>

          </div>
        </div>

      </accordion-tab>
    </accordion>
  </div>
</template>

<script>
import moment from 'moment'

import Service from '@/services/ask-genera/contratti-vendita-service'
import UtilityService from '@/services/ask-management/utility-service'

import PrimeButton from 'primevue/button'
import PrimeCheckbox from 'primevue/checkbox';
import PrimeInputNumber from 'primevue/inputnumber'
import PrimeTextarea from 'primevue/textarea'

export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  
  components: {
    PrimeButton,
    PrimeCheckbox,
    PrimeInputNumber,
    PrimeTextarea,
  },

  data() {
    return {
      page:{
        name: 'contratti-vendita-modifica-massiva',
      },

      sended: false,
      success: false,

      showClonedResults: false,
      clonedContracts: [],

      data_: {
        contrattiIds: this.data,

        item: {
          data_firma: null,
          data_inizio: null,
          data_fine: null,
          note: '',
          fee: null,

          cod_type_contratto: -1,
          cod_type_fatturazione: -1,
          cod_type_spedizione: -1,
          cod_type_periodo: -1,
          cod_type_pay: -1,
          cod_type_scadenza: -1,
          cod_type_iva: -1,
          cod_agente: -1,
          cod_type_rid: -1,
          cod_rappresentante: -1,
          stato: -1,
          motivazione_stato: -1,
          motivazione_stato_testo: ''
        },

        tipiContrattoVendita: [],
        tipiFatturazione: [],
        tipiSpedizione: [],
        tipiPeriodoFatturazione: [],
        tipiMetodoPagamentoCliente: [],
        giorniScadenza: [],
        tipiAliquotaIva:[],
        listaAgenti: [],
        tipiRid: [],
        listaRappresentanti: [],
        tipiStatoContratto: [],
        motivazioniStatoContrattoKo: [],


        makeClone: false
      },
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)

    this.utilityService = new UtilityService(this.$http, this.$eventBus)
    this.getListaAgenti()
    this.getListaRappresentanti()
    this.getGiorniScadenza()
    this.getTipiAliquotaIva()
    this.getTipiContrattoVendita()
    this.getTipiFatturazione()
    this.getTipiMetodoPagamentoCliente()
    this.getTipiRid()
    this.getTipiPeriodoFatturazione()
    this.getTipiSpedizione()
    this.geTipiStatoContratto()
    this.geMotivazioniStatoContrattoKo()
  },

  
  methods:{

    onCancelButton(){
      this._reset()

      this.$eventBus.emit('dialog-return-cancel-button', {})
    },

    ////

    onUpdateButton(/** event **/){
      const ids = [...this.data_.contrattiIds]

      const data = Object.entries({...this.data_.item})
      .map(([key, value])=>{
        if( key.startsWith('cod_') ){
          if(value == -1){
            value = null
          }
        }

        if( typeof(value) == 'string' ){
          value.trim()
          if( value == '' ){
            value = null
          }
        }

        return [key, value]
      })
      .reduce((obj, [key, value]) => {
        return {
          ...obj,
          [key]: value
        };
      }, {})

      const len = Object.values(data)
      .filter( (value) => value !== null )
      .length

      if(len != 0){

        if(!this.data_.makeClone){
          this.service.modificaContratti({
            data,
            ids
          }).then((res) => {
            this.sended = true
            this.success = res.success
          })
        }else{
          this.service.clonaContratti({
            data,
            ids
          }).then((res) => {
            this.sended = true
            this.success = res.success

            this.showClonedResults = true
            this.clonedContracts = res.contracts
          })
        }

      }else{
        alert(`Nulla da ${ (this.data_.makeClone)? 'clonare': 'modificare' }`)
      }
    },

    ////

    _reset(){
      this.sended = false
      this.success = false

      this.showClonedResults = false
      this.clonedContracts = []

      this.data_.contrattiIds = []

      this.data_.item.data_firma = null
      this.data_.item.data_inizio = null
      this.data_.item.data_fine = null
      this.data_.item.note = ''
      this.data_.item.fee = null

      this.data_.item.cod_type_contratto = -1
      this.data_.item.cod_type_fatturazione = -1
      this.data_.item.cod_type_spedizione = -1
      this.data_.item.cod_type_periodo = -1
      this.data_.item.cod_type_pay = -1
      this.data_.item.cod_type_scadenza = -1
      this.data_.item.cod_type_iva = -1
      this.data_.item.cod_agente = -1
      this.data_.item.cod_type_rid = -1
      this.data_.item.cod_rappresentante = -1
      this.data_.item.stato = -1
      this.data_.item.motivazione_stato = -1
      this.data_.item.motivazione_stato_testo = ''
      

      this.data_.tipiContrattoVendita = []
      this.data_.tipiFatturazione = []
      this.data_.tipiSpedizione = []
      this.data_.tipiPeriodoFatturazione = []
      this.data_.tipiMetodoPagamentoCliente = []
      this.data_.giorniScadenza = []
      this.data_.tipiAliquotaIva =[]
      this.data_.listaAgenti = []
      this.data_.tipiRid = []
      this.data_.listaRappresentanti = []
      this.tipiStatoContratto = [],
      this.motivazioniStatoContrattoKo = [],

      this.data_.makeClone = false
    },

    navigateToTab(href){
      window.open(href, '_blank')
    },

    getTipiContrattoVendita(){
      this.utilityService.getTipiContrattoVendita().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data_.tipiContrattoVendita = res.items
      })
    },

    getTipiFatturazione(){
      this.utilityService.getTipiFatturazione().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data_.tipiFatturazione = res.items
      })
    },

    getTipiSpedizione(){
      this.utilityService.getTipiSpedizione().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data_.tipiSpedizione = res.items
      })
    },

    getTipiPeriodoFatturazione(){
      this.utilityService.getTipiPeriodoFatturazione().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data_.tipiPeriodoFatturazione = res.items
      })
    },

    getTipiMetodoPagamentoCliente(){
      this.utilityService.getTipiMetodoPagamentoCliente().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data_.tipiMetodoPagamentoCliente = res.items
      })
    },

    getGiorniScadenza(){
      this.utilityService.getGiorniScadenza().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data_.giorniScadenza = res.items
      })
    },

    getTipiAliquotaIva(){
      this.utilityService.getTipiAliquotaIva().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data_.tipiAliquotaIva = res.items
      })
    },

    getListaAgenti(){
      this.utilityService.getAgenti().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data_.listaAgenti = res.items
      })
    },

    getTipiRid(){
      this.utilityService.getTipiRid().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data_.tipiRid = res.items
      })
    },

    getListaRappresentanti(){
      this.utilityService.getListaRappresentanti().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data_.listaRappresentanti = res.items
      })
    },
    geTipiStatoContratto(){
      this.utilityService.geTipiStatoContratto().then((res) => {
        res.items.unshift({
          value: -1,
          name: 'Nessuno'
        })

        this.data_.tipiStatoContratto = res.items
      })
    },
    geMotivazioniStatoContrattoKo(){
      this.utilityService.geMotivazioniStatoContrattoKo().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data_.motivazioniStatoContrattoKo = res.items
      })
    },
  },

  computed:{
    dataFirma: {
      get: function() {
        return (this.data_.item.data_firma !== null && this.data_.item.data_firma !== '')? moment(this.data_.item.data_firma).toDate(): null
      },
      set: function(value) {
        if(value instanceof Date && !isNaN(value.valueOf())){
          this.data_.item.data_firma = moment(value).format('YYYY-MM-DD')
        }

        if( (value === null) || (value === '')){
          this.data_.item.data_firma = null
        }
      }
    },

    dataInizio: {
      get: function() {
        return (this.data_.item.data_inizio !== null && this.data_.item.data_inizio !== '')? moment(this.data_.item.data_inizio).toDate(): null
      },
      set: function(value) {
        if(value instanceof Date && !isNaN(value.valueOf())){
          this.data_.item.data_inizio = moment(value).format('YYYY-MM-DD')
        }

        if( (value === null) || (value === '')){
          this.data_.item.data_inizio = null
        }
      }
    },

    dataFine: {
      get: function() {
        return (this.data_.item.data_fine !== null && this.data_.item.data_fine !== '')? moment(this.data_.item.data_fine).toDate(): null
      },
      set: function(value) {
        if(value instanceof Date && !isNaN(value.valueOf())){
          this.data_.item.data_fine = moment(value).format('YYYY-MM-DD')
        }

        if( (value === null) || (value === '')){
          this.data_.item.data_fine = null
        }
      }
    },
  },
}
</script>

<style scoped>
  
</style>
